
export function stringify(jsonObj) {
    // input is json object: [{ "name": "facebook", "url": "testFB" }]
    // output should be like this: [{name:"facebook",url:"testFB"}]
    const json = JSON.stringify(jsonObj);
    const unquoted = json.replace(/"([^"]+)":/g, '$1:');
    return unquoted;
  }
